module.exports = __webpack_public_path__ + "assets/img/o8.9a0cea2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/picture/o8.jpg
// module id = ugC+
// module chunks = 1